// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"2f020136","108":"c54749c4","396":"3df3f33e","636":"5d27a1ec","671":"a1f2feb4","710":"a1f2feb4","896":"89fc1d59"}[chunkId] + ".chunk.css";
};